import React, { Component } from 'react';
import BlockButton from 'components/UI/BlockButton';
import RegistrationTwoStepsForm from 'components/Registration/RegistrationTwoStepsForm';
import Immutable from 'immutable';
import BlockTitle from 'components/UI/BlockTitle';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import i18n from 'helpers/i18n';
const styles = (theme) => ({
  addButton: {
    backgroundColor: 'transparent',
    padding: 0,
    boxShadow: '0 5px 20px rgba(0,0,0,0.21)',
    '&:hover': {
      boxShadow: '0 5px 5px rgba(0,0,0,0.21)',
      backgroundColor: 'transparent',
    },
  },
  addIcon: {
    width: 50,
    height: 50,
    color: '#EB9250',
    verticalAlign: 'middle',
    margin: '-5px',
  },
  color: {
    color: theme.palette.primary.main,
  },
  inline: {
    display: 'inline-block',
  },
  h2: {
    color: theme.palette.primary.main,
    textAlign: 'center',
    padding: '0 20px 20px',
  },
  h5: {
    textAlign: 'center',
  },
  h6: {
    fontWeight: 'normal',
  },
  caption: {
    display: 'block',
    textAlign: 'center',
    marginBottom: 5,
  },
  body1: {
    textAlign: 'center',
    marginBottom: 10,
  },
});
class EventSubscriptionVisitor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleMode: false,
      userEmail: false,
      log: undefined,
    };
  }
  _onRegistrationComplete = (r) => {
    const { onClose, onSubscriptionComplete } = this.props;
    if (onSubscriptionComplete !== undefined) onSubscriptionComplete(r);
    else onClose();
  };
  render() {
    const {
      $$event,
      $$events,
      onClose,
      classes,
      onResize,
      // userRole,
    } = this.props;
    const {
      visibleMode,
      // userEmail,
    } = this.state;
    let ef;
    if ($$event !== undefined && $$event.get('id') !== undefined)
      ef = {
        fromEvent: $$event.get('id'),
      };
    else if ($$events !== undefined && $$events.get(0) !== undefined)
      ef = {
        fromEvents: JSON.stringify($$events.map((e) => e.get('id')).toArray()),
      };
    const extraFields = Immutable.fromJS(ef);
    return (
      <div>
        <RegistrationTwoStepsForm
          extraFields={extraFields}
          onClose={onClose}
          onFormComplete={this._onRegistrationComplete}
          $$event={$$event}
          $$events={$$events}
          title={i18n.get('subscriptionFormVisitorTitle')}
          onResize={onResize}
        />
      </div>
    );
  }
}
// export default ;
export default withStyles(styles)(EventSubscriptionVisitor);



// WEBPACK FOOTER //
// ./src/components/Event/EventSubscriptionVisitor.jsx